import clsx from 'clsx'
import React, { CSSProperties } from 'react'

import { Background } from '@Components/Background'
import { Container } from '@Components/Container'
import { Elements } from '@Components/Elements'
import { Elements as ElementsGraphQL } from '@Components/Elements/Types'
import { ImageV3 } from '@Components/Image'
import { RTEContent } from '@Components/RTEContent'
import { Button } from '@CoreComponents/Buttons/Button'
import { BlockAppearance, PagePresentation, ReferenceContentFragment, RteField } from '@Generated/graphql'

import styles from './TilesCard.module.scss'

export const TilesCardGeneric = ({
  appearance,
  buttonLabel,
  campaignTag,
  cardAspectRatio,
  cardSize,
  cardVariant,
  disableLinks = false,
  elements = null,
  height,
  image,
  presentation,
  subTitle,
  title,
  width,
}: {
  appearance: BlockAppearance
  buttonLabel?: string
  campaignTag?: {
    appearance: BlockAppearance
    text: RteField
  }
  cardAspectRatio: string
  cardSize: string
  cardVariant: string
  disableLinks?: boolean
  elements?: ElementsGraphQL[] | null
  height?: number
  image?: string
  presentation: PagePresentation
  subTitle?: RteField | null
  title?: string
  width?: number
}) => {
  const { asset, backgroundColor, textColor } = appearance

  const {
    asset: campaignTagAsset,
    backgroundColor: campaignTagBackgroundColor,
    textColor: campaignTagTextColor,
  } = campaignTag?.appearance || {}

  return (
    <div
      className={clsx(
        styles.card,
        styles[cardVariant],
        styles[cardSize],
        styles[cardAspectRatio],
        styles[presentation.toLowerCase()],
      )}
      style={{
        '--tile-background-color': backgroundColor,
        '--tile-text-color': textColor,
      } as CSSProperties}
    >
      {asset && <Background asset={asset as ReferenceContentFragment} />}
      {!asset && image && <ImageV3 alt={title || ''} draggable={false} height={height || 100} src={image} title={title} width={width || 100} />}
      {elements && <Elements dimWithText disableLinks={disableLinks} elements={elements} />}
      <div className={clsx(styles.content, (title || subTitle) && styles.withText)}>
        {(cardVariant !== 'background-without-text' && cardSize !== 'tiny') && (
          <>
            {campaignTag?.text && (
              <Container
                background={campaignTagAsset as ReferenceContentFragment}
                backgroundColor={campaignTagBackgroundColor || undefined}
                textColor={campaignTagTextColor || undefined}
                variant="minimal"
              >
                <RTEContent className={styles.campaignTag} data={campaignTag.text} />
              </Container>
            )}
            {cardVariant !== 'background-without-text' && title && (<p className={styles.title}>{title}</p>)}
            {cardVariant !== 'background-without-text' && subTitle && (<RTEContent className={styles.subTitle} data={subTitle} />)}
          </>
        )}
        {buttonLabel && (<Button className={styles.button} innerSpacing="medium" theme="transparent" type="button">{buttonLabel}</Button>)}
      </div>
    </div>
  )
}
